import { Layout, Menu, Typography } from "antd";
import {
  UserOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ScheduleOutlined,
  CloudUploadOutlined,
  CarOutlined,
  ToolOutlined,
  ExperimentOutlined,
  AuditOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Sider } = Layout;
const { Text } = Typography;

const menuItems = [
  {
    type: "group" as const,
    label: "Overview",
    children: [
      {
        key: "/dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
      },
    ],
  },
  {
    type: "group" as const,
    label: "Operations",
    children: [
      {
        key: "/",
        icon: <ExperimentOutlined />,
        label: "Weightment",
      },
      {
        key: "/drivers",
        icon: <CarOutlined />,
        label: "Drivers",
      },
      {
        key: "/labours",
        icon: <ToolOutlined />,
        label: "Labours",
      },
      {
        key: "/workflow",
        icon: <AuditOutlined />,
        label: "Workflow",
      },
    ],
  },
  {
    type: "group" as const,
    label: "Management",
    children: [
     {
        key: "/upload",
        icon: <CloudUploadOutlined />,
        label: "Upload",
      },
      {
        key: "/documents",
        icon: <DatabaseOutlined />,
        label: "Documents",
      },
      {
        key: "/reminders",
        icon: <ScheduleOutlined />,
        label: "Reminders",
      },
      {
        key: "/members",
        icon: <UserOutlined />,
        label: "Members",
      },
      {
        key: "/settings",
        icon: <SettingOutlined />,
        label: "Settings",
      },
    ],
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const allItems = menuItems.flatMap((group) => group.children);
  const selectedKey =
    allItems.find(
      (item) => item.key !== "/" && location.pathname.startsWith(item.key)
    )?.key || (location.pathname === "/" ? "/" : "");

  return (
    <Sider
      width={210}
      theme="dark"
      style={{
        position: "fixed",
        left: 0,
        top: 64,
        height: "calc(100vh - 64px)",
        borderRight: "1px solid rgba(255,255,255,0.04)",
        display: "flex",
        flexDirection: "column",
        zIndex: 100,
      }}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
        style={{ flex: 1, border: "none", paddingBottom: 16 }}
      />

      <div
        style={{
          padding: "14px 16px",
          borderTop: "1px solid rgba(255,255,255,0.06)",
          marginTop: "auto",
          textAlign: "center",
        }}
      >
        <Text
          style={{
            color: "#64748b",
            fontSize: 11,
            display: "block",
          }}
        >
          Access Warehousing v1.0
        </Text>
      </div>
    </Sider>
  );
};

export default Sidebar;
